import React, { Component } from "react";
import $ from 'jquery';
import classnames from "classnames";

class LeftScriptParticipant extends Component {

  constructor(props) {
    super(props);
  
    this.state = {
        show_cart: false,
        quantity: 0,
        userData: JSON.parse(localStorage.getItem('userData'))
    };

    window.cart = [];
  }

  showCart = () => {
      this.setState({show_cart: true});
  }

  hideCart = () => {
      this.setState({show_cart: false});
  }

  incrementQuantity = () => {
      let quantity = parseInt($('#quantity').text());
      if (quantity < 100) {
          $('#quantity').text(quantity + 1);
      }
  }

  decrementQuantity = () => {
      let quantity = parseInt($('#quantity').text());
      if (quantity > 0) {
          $('#quantity').text(quantity - 1);
      }
  }

  setQuantity = () => {

    this.hideCart();

    let scriptId = $('.carousel-item.active').attr('id');
    let quantity = parseInt($('#quantity').text());

    if (window.cart.length > 0) {
        let scriptIdExists = false;

        window.cart.forEach((userCart)=>{
            if (userCart.scriptId == scriptId) {
                userCart.quantity = quantity;
                scriptIdExists = true;
            }
        });

        if (scriptIdExists === false) {
            let cartData = {"scriptId": scriptId, "quantity": quantity};
            window.cart.push(cartData);
        }
    } else {
        let cartData = {"scriptId": scriptId, "quantity": quantity};
        window.cart.push(cartData);
    }

    let cartQuantity = 0;
    window.cart.forEach((userCart)=>{
        cartQuantity += userCart.quantity;
    });

    this.setState({quantity: cartQuantity});
    $('#quantity').text(6);
  }

  render() {

    return (
        <div className="col-lg-6 col-sm-6 col-6">
        { this.state.userData.sessionData.groupId == 2 ? (
            <div className="mt-60">
                <div id="wine-script" data-interval="false" className="carousel slide script-info" data-ride="carousel">
                  <div className="carousel-inner guest-left-wine scroller">
                    {
                      this.state.userData.sessionData.scriptDetail.map((opt, i) =>
                        <div className="carousel-item" key={i} id={opt.id}>
                        <div className="left-section">
                        <h2 className="item-name mb-2"><span className="font-20"><span className="fitness-counter1 font-26">{i+1}</span>/{this.state.userData.sessionData.scriptDetail.length} {this.state.userData.sessionData.scriptType}</span></h2>
                            <h3 className="second-heading my-3">{opt.name}</h3>
                            <div className="wine-video-holder">
                              <img className="wine-img-width" src={opt.image} />
                            </div>                        
                            <div className="item-description py-4">
                              <div className="row">
                                <ul className="col-12 col-md-12 list-info my-0">
                                    {opt.attribute.map(function(attrb, inf){
                                     return <li key={inf}><span>{attrb.attrLabel}</span><span>{attrb.attrValue}</span></li>   
                                    })}
                                </ul>
                              </div>
                            </div>                    
                          </div>
                        </div>
                    )}
              </div>
              
              <div className="mt-4 position-relative">
                <span className="text-white badge" id="cart-quantity">{this.state.quantity}</span>
                <button type="button" className="shopping-btn" onClick={ this.showCart }><img src="./images/shopping-icon.png" />Order Wine</button>
                <button type="button" data-toggle="modal" data-target="#show-details4" className="shopping-btn ml-2 d-none">Show Details</button>
              </div>

              <a className="carousel-control-prev d-none" href="#wine-script" data-slide="prev">
                <span className="carousel-control-prev-icon"></span>
              </a>
              <a className="carousel-control-next d-none" href="#wine-script" data-slide="next">
                <span className="carousel-control-next-icon"></span>
              </a>

              <div className={classnames({'d-flex':true, 'add-to-cart':true, 'opacity-zero':!this.state.show_cart})}>
                  <div className="d-flex purple_border radius-10 w-110 text-white mt-3">
                    <div className="flex-fill text-center p-2 purple_border_right cursor-pointer minus" onClick={this.decrementQuantity.bind(this)}><i className="fa fa-minus"></i></div>
                    <div className="flex-fill text-center p-2 purple_border_right"><p className="mb-0" id="quantity">6</p></div>
                    <div className="flex-fill text-center p-2 cursor-pointer plus" onClick={this.incrementQuantity.bind(this)}><i className="fa fa-plus"></i></div>
                  </div>
                  <div className="ml-4 mt-3">
                    <a href="#!" className="save-btn btn btn-primary radius-10 mx-auto" onClick={this.setQuantity.bind(this)}>OK</a>
                  </div>
              </div>
            </div>
          </div>
        ) : ( <div></div> )
    }
    </div>
      
    );
  }
}

export default LeftScriptParticipant;